// extracted by mini-css-extract-plugin
export default {"content":"form-part_content__zASgV","tipText":"form-part_tipText__xP4lT","errorMsg":"form-part_errorMsg__jy8A7"};